import React from 'react';
import SMSearchFormBaseView from 'components/search/SMSearchFormBaseView';

class SMMobileSearchFormView extends SMSearchFormBaseView {

  constructor(props) {
    super(props);
  }

  eventTypeDidSelect(e) {
    const eventType = e.currentTarget.value;
    let priceType = 'hourly';
    if (eventType == 'stay') {
      priceType = 'stay';
    }
    this.setState({
      priceType: priceType
    });
    if(this.props.delegate && typeof this.props.delegate.eventTypeDidSelect === 'function'){
      this.props.delegate.eventTypeDidSelect(e.currentTarget.value);
    }
  }

  render() {
    let responsiveClass={};
    switch (this.state.priceType) {
      case 'hourly':
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-4',
          priceType: 'col-xs-3 col-sm-3 col-md-1',
          start: 'col-xs-4 col-sm-4 col-md-2',
          end: '',
          startHour: 'col-xs-4 col-sm-4 col-md-2',
          endHour: 'col-xs-4 col-sm-4 col-md-2',
          capacity: 'col-xs-12 col-sm-12 col-md-2 search-filter__person-num',
        };
        break;
      case 'stay':
        responsiveClass = {
          area: 'col-xs-12 col-sm-12 col-md-4',
          priceType: '',
          start: 'col-xs-6 col-sm-6 col-md-2',
          end: 'col-xs-6 col-sm-6 col-md-2',
          capacity: 'col-xs-12 col-sm-12 col-md-2 search-filter__person-num',
        };
        break;
      default:
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-3',
          priceType: 'col-xs-3 col-sm-3 col-md-1',
          start: 'col-xs-6 col-sm-6 col-md-3',
          end: 'col-xs-6 col-sm-6 col-md-3',
          capacity: 'col-xs-12 col-sm-12 col-md-2 search-filter__person-num',
        };
    }
    return (
      <div className="container">
        <input type="hidden" name="event_type" value={this.props.eventType} />
        <div className="col-xs-12 col-sm-12">
          <div className="mdl-textfield w100pa">
            <span className="service-select material-select">
              <select className="w100pa" value={this.props.eventType || ''} onChange={this.eventTypeDidSelect.bind(this)}>
                <option value="">目的</option>
                {this.props.eventTypeList.map((eventType)=>{
                  return (<option key={eventType.id} value={eventType.name}>{eventType.name_text}</option>);
                })}
                <option key={999} value={'stay'}>宿泊</option>
              </select>
            </span>
          </div>
        </div>
        {this.renderAreaField(responsiveClass.area)}
        {this.renderPriceTypeSelect(responsiveClass.priceType)}
        {this.renderStartedAtField(responsiveClass.start)}
        {this.renderStartedHourField(responsiveClass.startHour)}
        {this.renderEndedAtField(responsiveClass.end)}
        {this.renderEndedHourField(responsiveClass.endHour)}
        {this.renderCapacityRange(responsiveClass.capacity)}
        {this.renderDatePicker('datetime-layout clearfix')}
      </div>
    );
  }
}

export default SMMobileSearchFormView;



// WEBPACK FOOTER //
// ./app/javascript/components/header/SMMobileSearchFormView.jsx